import { MapPin } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { CITIES } from "../lib/data";

export const Coverage = () => (
  <section id="zone" data-testid="coverage-area-section" className="py-20 md:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
      <Reveal>
        <Overline>Zone d'intervention</Overline>
        <h2 className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
          Lille et toute sa métropole
        </h2>
        <p className="mt-4 text-base text-slate-600 max-w-xl mx-auto leading-relaxed">
          Basés à Lille, nous intervenons rapidement dans toute la métropole lilloise — et au-delà
          sur simple demande.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div data-testid="coverage-cities" className="mt-10 flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {CITIES.map((city) => (
            <span
              key={city}
              data-testid={`coverage-city-${city.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="inline-flex items-center gap-2 rounded-full border border-sky-200 bg-sky-50 px-5 py-2.5 text-sm font-semibold text-sky-800 transition-colors hover:bg-sky-600 hover:text-white hover:border-sky-600 cursor-default"
            >
              <MapPin size={14} /> {city}
            </span>
          ))}
          <span className="inline-flex items-center gap-2 rounded-full border border-dashed border-emerald-300 bg-emerald-50 px-5 py-2.5 text-sm font-semibold text-emerald-700">
            + alentours sur demande
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);
